import React, { lazy, Suspense } from 'react'
import { Spin } from 'antd'

const AceEditorLazy = lazy(() => import('./AceEditor'))

const AceEditorFallback = () => (
  <div style={{ padding: 16, textAlign: 'center', minHeight: 120 }}>
    <Spin tip="Загрузка редактора..." />
  </div>
)

export default function AceEditorAsync(props) {
  return (
    <Suspense fallback={<AceEditorFallback />}>
      <AceEditorLazy {...props} />
    </Suspense>
  )
}
